import React from 'react';
import './../LegalPage.css'; // On utilise le CSS partagé

function MentionsLegales() {
  return (
    <div className="legal-page-container">
      <h1>Mentions Légales</h1>
      <p><em>Conformément aux dispositions des Articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie numérique, dite L.C.E.N., il est porté à la connaissance des utilisateurs et visiteurs du site www.couleursirene.fr les présentes mentions légales.</em></p>
      
      <h2>1. Éditeur du Site</h2>
      <p>
        <strong>Raison Sociale :</strong> MESLE Magali<br/>
        <strong>Adresse :</strong> 101 impasse rançon, 32130 POLASTRON<br/>
        <strong>Immatriculation :</strong> Immatriculée au répertoire des métiers à la chambre des métiers et de l'Artisanat du GERS sous le numéro 904 952 272 00022<br/>
        <strong>Téléphone :</strong> <a href="tel:+33668150574">06 68 15 05 74</a><br/>
        <strong>E-mail :</strong> <a href="mailto:contact@couleursirene.fr">contact@couleursirene.fr</a><br/>
        <strong>Directeur de la publication :</strong> Magali MESLE
      </p>

      <h2>2. Hébergement</h2>
      <p>
        <strong>Hébergeur :</strong> SAS OVH<br/>
        <strong>Adresse :</strong> 2 rue Kellermann - 59100 Roubaix - France.<br/>
        <strong>Contact :</strong> 1007
      </p>

      <h2>3. Droits d'auteur et responsabilité</h2>
      <p>
        Tous les textes, images, vidéos, graphismes, logo, icônes, et contenus présents sur le site www.couleursirene.fr sont la propriété de la société Couleur Sirène.
      </p>
      <p>
        Sauf en cas d'autorisation formelle écrite et préalable, la reproduction ainsi que toute utilisation des contenus du site www.couleursirene.fr autre que la consultation individuelle et privée sont interdites.
      </p>
      <p>
        Toute exploitation non autorisée du site ou de l’un des éléments qu’il contient sera considérée comme constitutive d’une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
      </p>
      <p>
        Le site www.couleursirene.fr a pour objet de fournir une information concernant l’activité de la société. Magali MESLE s’efforce de fournir des informations aussi précises que possible. Toutefois, il ne pourra être tenu responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu’elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations. Toutes les informations indiquées sur le site www.couleursirene.fr sont données à titre indicatif, et sont susceptibles d’évoluer.
      </p>

      <h2>4. Informations personnelles et libertés</h2>
      <p>
        Les informations recueillies font l’objet d’un traitement informatique et sont nécessaires à la gestion de la transaction et au bon déroulement du processus de commande sur le site www.couleursirene.fr. Le destinataire des données est uniquement le site www.couleursirene.fr.
      </p>
      <p>
        Conformément à la loi « informatique et libertés » du 6 janvier 1978 modifiée en 2004, vous bénéficiez d’un droit d’accès et de rectification aux informations qui vous concernent, que vous pouvez exercer en vous adressant à <a href="mailto:contact@couleursirene.fr">contact@couleursirene.fr</a>.
      </p>
      <p>
        Vous pouvez également, pour des motifs légitimes, vous opposer au traitement des données vous concernant.
      </p>
    </div>
  );
}

export default MentionsLegales;